"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyElectricityWithdraw = applyElectricityWithdraw;
exports.buildMonthlyBill = buildMonthlyBill;
exports.confirmBill = confirmBill;
exports.exportDailyUsage = exportDailyUsage;
exports.exportMonthlyBill = exportMonthlyBill;
exports.getBillDetail = getBillDetail;
exports.getDailyUsageList = getDailyUsageList;
exports.getManageOverview = getManageOverview;
exports.getMerchantStoreList = getMerchantStoreList;
exports.getMerchantWithdrawOverview = getMerchantWithdrawOverview;
exports.getMonthlyBillList = getMonthlyBillList;
exports.getWithdrawRecordList = getWithdrawRecordList;
exports.saveElectricityConfig = saveElectricityConfig;
exports.settleBill = settleBill;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _request = _interopRequireWildcard(require("@/utils/request"));
var _auth = require("@/utils/auth");
var _elementUi = require("element-ui");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var prefix = '/agentapi/merchant_electricity';
function withAuthParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, params), {}, {
    token: (0, _auth.getToken)(),
    user_id: (0, _auth.getToken)('user_id'),
    agent_id: params.agent_id || (0, _auth.getToken)('agent_id')
  });
}
function pickExportParams(params) {
  var result = {};
  Object.keys(params).forEach(function (key) {
    var val = params[key];
    if (val !== '' && val !== null && val !== undefined) {
      result[key] = val;
    }
  });
  return result;
}
function downloadCsvExport(_x) {
  return _downloadCsvExport.apply(this, arguments);
}
function _downloadCsvExport() {
  _downloadCsvExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(path) {
    var params,
      defaultFilename,
      blob,
      isJsonBlob,
      text,
      json,
      _args = arguments,
      _t;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          defaultFilename = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'export.csv';
          _context.next = 1;
          return _request.default.get("".concat(prefix, "/").concat(path), {
            params: withAuthParams(pickExportParams(params)),
            responseType: 'blob'
          });
        case 1:
          blob = _context.sent;
          isJsonBlob = blob.type && (blob.type.includes('application/json') || blob.type.includes('text/json'));
          if (!(isJsonBlob || blob.size < 4096)) {
            _context.next = 8;
            break;
          }
          _context.next = 2;
          return blob.text();
        case 2:
          text = _context.sent;
          if (!(text.trim().charAt(0) === '{')) {
            _context.next = 8;
            break;
          }
          _context.prev = 3;
          json = JSON.parse(text);
          if (!(json.code !== undefined && parseInt(json.code, 10) !== 0)) {
            _context.next = 4;
            break;
          }
          _elementUi.Message.error(json.msg || '导出失败');
          return _context.abrupt("return", Promise.reject(json));
        case 4:
          _context.next = 6;
          break;
        case 5:
          _context.prev = 5;
          _t = _context["catch"](3);
          if (!isJsonBlob) {
            _context.next = 6;
            break;
          }
          _elementUi.Message.error('导出失败');
          return _context.abrupt("return", Promise.reject(_t));
        case 6:
          if (!isJsonBlob) {
            _context.next = 7;
            break;
          }
          _elementUi.Message.error('导出失败');
          return _context.abrupt("return", Promise.reject(new Error('export failed')));
        case 7:
          triggerDownload(new Blob([text], {
            type: 'text/csv;charset=utf-8'
          }), defaultFilename);
          _elementUi.Message.success('导出成功');
          return _context.abrupt("return");
        case 8:
          triggerDownload(blob, defaultFilename);
          _elementUi.Message.success('导出成功');
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 5]]);
  }));
  return _downloadCsvExport.apply(this, arguments);
}
function triggerDownload(blob, filename) {
  var url = window.URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}
function getMerchantStoreList(merchantAid) {
  return (0, _request.$get)("".concat(prefix, "/merchant_store_list"), {
    merchant_aid: merchantAid
  });
}
function saveElectricityConfig(data) {
  return (0, _request.$post)("".concat(prefix, "/save_config"), data);
}
function getManageOverview() {
  return (0, _request.$get)("".concat(prefix, "/manage_overview"), {});
}
function getMonthlyBillList(params) {
  return (0, _request.$get)("".concat(prefix, "/monthly_bill_list"), _objectSpread({
    summary_only: 1,
    limit: 20,
    start: 0
  }, params));
}
function getBillDetail(billId) {
  return (0, _request.$get)("".concat(prefix, "/bill_detail"), {
    bill_id: billId
  });
}
function confirmBill(billId) {
  return (0, _request.$post)("".concat(prefix, "/confirm_bill"), {
    bill_id: billId
  });
}
function settleBill(billId) {
  return (0, _request.$post)("".concat(prefix, "/settle_bill"), {
    bill_id: billId
  });
}
function buildMonthlyBill(billMonth) {
  return (0, _request.$post)("".concat(prefix, "/build_monthly_bill"), {
    bill_month: billMonth
  });
}
function getDailyUsageList(params) {
  return (0, _request.$get)("".concat(prefix, "/daily_usage_list"), _objectSpread({
    limit: 20,
    start: 0
  }, params));
}
function getWithdrawRecordList(params) {
  return (0, _request.$get)("".concat(prefix, "/withdraw_record_list"), _objectSpread({
    limit: 20,
    start: 0
  }, params));
}
function getMerchantWithdrawOverview(merchantAid) {
  return (0, _request.$get)("".concat(prefix, "/merchant_withdraw_overview"), {
    merchant_aid: merchantAid
  });
}
function applyElectricityWithdraw(data) {
  return (0, _request.$post)("".concat(prefix, "/apply_withdraw"), data);
}
function exportMonthlyBill() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filename = params.bill_id ? "\u5546\u6237\u7535\u8D39\u8D26\u5355_".concat(params.bill_month || '', ".csv") : "\u5546\u6237\u7535\u8D39\u6708\u5EA6\u8D26\u5355_".concat(params.bill_month || '全部', ".csv");
  return downloadCsvExport('export_monthly_bill', _objectSpread({
    summary_only: 1
  }, params), filename);
}
function exportDailyUsage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filename = "\u5546\u6237\u65E5\u7528\u7535\u91CF\u660E\u7EC6_".concat(params.date_start || '', "_").concat(params.date_end || '', ".csv");
  return downloadCsvExport('export_daily_usage', params, filename);
}